import { CREATE_PASSWORD_RECOVERY_TOKEN } from 'actions/Types';
import { passwordRecoveryTokenStatuses } from '../constants/passwordRecoveryTokenStatus';

export default (state = passwordRecoveryTokenStatuses.unsubmitted, action) => {
  if (action.type === `${CREATE_PASSWORD_RECOVERY_TOKEN}`) {
    return passwordRecoveryTokenStatuses.requesting;
  }

  if (action.type === `${CREATE_PASSWORD_RECOVERY_TOKEN}_SUCCESS`) {
    return passwordRecoveryTokenStatuses.completed;
  }

  if (action.type === `${CREATE_PASSWORD_RECOVERY_TOKEN}_ERROR`) {
    return passwordRecoveryTokenStatuses.error;
  }

  return state;
};
